
(function($){
  $(function(){

    var s2g = {
      init : function(){
        s2g.clicks();
      },
      clicks : function(){

        // Increase New Product Sales
        $('a[href^="mailto:sales@ecessa.com"]').on('click', function(){
          s2g.gevent('sales', 'mailto', window.location.href);
        });

        // Partnership Applications
        $('body').on('submit', '#hsForm_fdb582b3-d5c9-492a-9273-fda17342dd5b .hs_submit input', function(){
          s2g.gevent('partner', 'submit', 'partner-app-form');
        });
        $('body').on('submit', '#hsForm_c5a97f24-6729-49d7-94ba-ccbd3f9daa14 .hs_submit input', function(){
          s2g.gevent('partner', 'submit', 'program-overview');
        });
        $('body').on('submit', '#hsForm_72a945a0-46da-4ab8-a6cd-cc453dc9d829 .hs_submit input', function(){
          s2g.gevent('partner', 'submit', 'deal-reg-form');
        });

        // Support Current Customers
        $('a[href^="mailto:help@ecessa.com"]').on('click', function(){
          s2g.gevent('support', 'mailto', window.location.href);
        });
        $('a[href^="mailto:info@ecessa.com"]').on('click', function(){
          s2g.gevent('support', 'mailto', window.location.href);
        });
        $('body').on('mousedown', '#hsForm_271b5006-dbcd-4ab3-9c68-e5c8cb018f3a .hs_submit input', function(){
          var whref = window.location.pathname;
          if(whref === '/contact/'){
            s2g.gevent('support', 'submit', 'contact-us');
          } else {
            s2g.gevent('sales', 'submit', whref);
          }
        });
        $('a.footer-contact-icon.phone').on('mousedown', function(){
          s2g.gevent('c2c', 'c2c', window.location.href);
        });

        // Enhance Online Experiance
        $('.embed-container iframe').on('mousedown', function(){
          var vtitle = $(this).parents('.featured').find('.video-text h3').text();
          s2g.gevent('video', 'play', vtitle);
        });
        $('#casestudies a[href$=".pdf"]').on('click', function(){
          var dtitle = $(this).parents('.featured').find('h2 a').text();
          s2g.gevent('wp-cs', 'download', dtitle);
        });

        // Increase Share of Voice
        $('a[href*="opt-in"]').on('click', function(){
          s2g.gevent('blog', 'subscribe', window.location.href);
        });

        // Amplify Social / Referral Outreach
        $('a.footer-icon.tw').on('click', function(){
          s2g.gsocial('twitter', 'follow', window.location.href);
        });
        $('a.footer-icon.fb').on('click', function(){
          s2g.gsocial('facebook', 'follow', window.location.href);
        });
        $('a.footer-icon.in').on('click', function(){
          s2g.gsocial('linkedin', 'follow', window.location.href);
        });
        $('a.footer-icon.go').on('click', function(){
          s2g.gsocial('google-plus', 'follow', window.location.href);
        });
        $('a.footer-icon.yt').on('click', function(){
          s2g.gsocial('youtube', 'follow', window.location.href);
        });

        $('a[href*="callto"]').on('click', function(){
          s2g.gevent('product-page', 'c2c', window.location.href);
        });

      },
      gevent : function(category, action, label){
        ga('send', 'event', category, action, label);
      },
      gsocial : function(category, action, label){
        ga('send', 'social', category, action, label);
      }
    };
    s2g.init();

  });
})(jQuery);
